import Account from "svelte-material-icons/Account.svelte"
import Cart from "svelte-material-icons/Cart.svelte"
import Cached from "svelte-material-icons/Cached.svelte"
import Information from "svelte-material-icons/Information.svelte"
import ShoppingSearch from "svelte-material-icons/ShoppingSearch.svelte"
import Email from "svelte-material-icons/Email.svelte"

export const services = [
    {
        title: "Impressum",
        url: "impressum",
        icon: Account,
        description: "Alle Unternehmensangaben auf einen Blick",
        inPreselectedDealerView: true,
    },
    {
        title: "Allgemeine Geschäftsbedingungen",
        url: "agb",
        icon: Cart,
        description: "Alle Bedingungen zu Ihrem Einkauf im Renz Online Shop",
        inPreselectedDealerView: true,
    },
    {
        title: "Datenschutz",
        url: "datenschutz",
        icon: ShoppingSearch,
        description: "Alle Datenschutzbestimmungen im Überblick",
        inPreselectedDealerView: true,
    },
    {
        title: "Widerruf",
        url: "widerruf",
        icon: Cached,
        description: "Erfahren Sie mehr zu den  Widerrufsbedingungen",
    },
    {
        title: "FAQ",
        url: "faq",
        icon: Information,
        description: "Die meist gestellten Fragen zu unseren Produkten und zum Shop",
    },
    {
        title: "Kontakt",
        url: "kontakt",
        icon: Email,
        description: "Bei weiteren Fragen nehmen Sie gerne Kontakt mit uns auf",
    },
]

export const homeProductTeaser = [
    {
        title1: "",
        title2: "Beliebte Briefkastenprodukte",
        path: "",
        moreLinkText: "",
        moreLinkURL: "/ersatzteile",
    },
]
